module.exports = __webpack_public_path__ + "img/Clone-Trooper-icon.203357ba.png";